export const iconFontAwesomeMedicalHealthHouseMedical = (
	<i className="fa-solid fa-house-medical"></i>
);
